import React from "react";

const CoffeeIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="97.861"
    viewBox="0 0 97.861 99.346"
    {...props}
  >
    <path
      fill={props.color}
      d="M38.554 1a3.27 3.27 0 00-2.756 1.602l-.002.004-7.791 13.412c-.898 1.541-.377 3.553 1.17 4.446h.002a3.259 3.259 0 001.633.447 3.263 3.263 0 002.814-1.617L41.415 5.88a3.275 3.275 0 00-1.168-4.443l-.004-.002h-.002a3.221 3.221 0 00-1.687-.435zm17.826.005a3.267 3.267 0 00-2.752 1.597l-.002.004-7.79 13.412c-.901 1.546-.368 3.552 1.169 4.445h.002l.002.002a3.258 3.258 0 001.63.446 3.263 3.263 0 002.815-1.617L59.245 5.88a3.275 3.275 0 00-1.168-4.443l-.006-.002-.003-.004a3.228 3.228 0 00-1.688-.428zM5.66 25.897c-2.672 0-4.86 2.186-4.86 4.85v30.379c0 20.512 16.708 37.22 37.23 37.22h6.36c19.184 0 34.948-14.627 36.931-33.29H91.47c2.963 0 5.39-2.427 5.39-5.39v-23.66c0-2.962-2.43-5.38-5.39-5.38h-9.875c-.069-2.613-2.21-4.729-4.836-4.729zm1.64 6.488h67.82v28.73c0 16.959-13.772 30.731-30.73 30.731h-6.36c-16.947 0-30.73-13.773-30.73-30.73zm74.32 4.74h8.74v21.43h-8.74zm-41.9 6.442a3.265 3.265 0 00-3.25 3.25v21.125c.012 2.302 1.501 4.354 3.717 5.031l12.799 3.977h.003l.004.002a3.258 3.258 0 004.07-2.137v-.002c.53-1.703-.432-3.542-2.136-4.072L42.97 67.03V46.817a3.265 3.265 0 00-3.25-3.25z"
      stroke={props.color}
      strokeWidth="2"
    />
  </svg>
);
export default CoffeeIcon;
